import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private menuOpenSubject = new BehaviorSubject<boolean>(false);
  menuOpen$ = this.menuOpenSubject.asObservable();

  private menuItemsSubject = new BehaviorSubject<any[]>([]);
  menuItems$ = this.menuItemsSubject.asObservable();

  toggleMenu() {
    console.log('Toggle menu called');
    this.menuOpenSubject.next(!this.menuOpenSubject.value);
  }

  closeMenu() {
    this.menuOpenSubject.next(false);
  }

  sendMenuItems(menuItems: any[]) {
    this.menuItemsSubject.next(menuItems);
  }
}